import {GoToCategory} from "../GoToItem";
import {useNeighbourhoodStore} from "../../../api/NeighbourhoodStore";
import {RemoteValue} from "../../../util/RemoteValue";
import {AppPages} from "../../../app-layout/AppPages";
import {UNASSIGNED_NEIGHBOURHOOD_ID} from "../../../api/Model";
import NeighbourhoodColorIcon from "../../neighbourhood-icon/NeighbourhoodColorIcon";
import {useGoToItems} from "./useGoToItems";

export function useNeighbourhoodGoToItems(): RemoteValue<GoToCategory> {
    const neighbourhoods = useNeighbourhoodStore(state => state.remoteValue);

    return useGoToItems(
        'Neighbourhoods',
        AppPages.neighbourhoodVisitReport.requiredPermissions,
        neighbourhoods,
        neighbourhoods => neighbourhoods
            .filter(n => n.id !== UNASSIGNED_NEIGHBOURHOOD_ID)
            .map(neighbourhood => ({
                id: `neighbourhood-${neighbourhood.id}`,
                label: neighbourhood.name,
                icon: () => <NeighbourhoodColorIcon neighbourhood={neighbourhood}/>,
                url: pageUrl => pageUrl(AppPages.neighbourhoodVisitReport, {}, {search: neighbourhood.name}),
            })),
    );
}
